import {type ReactNode} from 'react';
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle
} from '@kroll-resolver-crisp/ui-components-react';

type ChartCardProps = {
  readonly block: {
    readonly id: string;
    readonly type: string;
    readonly title: string;
    readonly description?: string;
  };
  // True when there is nothing to draw; the card says so instead of rendering an empty plot.
  readonly empty: boolean;
  // The view switcher, when the block offers more than one view.
  readonly actions?: ReactNode;
  readonly children: ReactNode;
};

// The frame every chart block shares: titled card, data attributes the renderer test reads, and the
// one "nothing to chart" state.
export function ChartCard({block, empty, actions, children}: ChartCardProps) {
  return (
    <Card data-block-id={block.id} data-block-type={block.type}>
      <CardHeader>
        <CardTitle>{block.title}</CardTitle>
        {block.description ? <CardDescription>{block.description}</CardDescription> : null}
        {actions ? <CardAction>{actions}</CardAction> : null}
      </CardHeader>
      <CardContent>
        {empty ? (
          <Empty className="py-10">
            <EmptyHeader>
              <EmptyTitle>Nothing to chart</EmptyTitle>
              <EmptyDescription>No rows in this range.</EmptyDescription>
            </EmptyHeader>
          </Empty>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
